// extracted by mini-css-extract-plugin
export default {"wrapper":"CircularLoading_wrapper__oD0G3","container":"CircularLoading_container__gDHva","logo-img":"CircularLoading_logo-img__Ienig","sub-title":"CircularLoading_sub-title__1-pYG"};